import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgArrowUpLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M23 12.001L12 1.00098M12 1.00098L1 12.001M12 1.00098V23.001"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgArrowUpLarge.displayName = 'SvgArrowUpLarge';
const ArrowUpLarge = withForgeIconProps(SvgArrowUpLarge, {
  name: 'ArrowUp',
  usage: 'Use to indicate the ability to move an item up.',
  related: 'move, direction',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default ArrowUpLarge;
